import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
import { computed, ref } from 'vue';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { useDetailRoute } from '@/presentation/pages/workspace-detail/composables/use-detail-route';
import _ from 'lodash';
export const useSpace = createSharedComposable(() => {
    const spaceService = injectService(SpaceService);
    const { spaceId } = useDetailRoute();
    const spaceInfo = ref({});
    spaceService.subscribeSpaceInfo((newVal) => {
        spaceInfo.value = newVal;
    });
    const spaceSetting = ref({});
    spaceService.subscribeSpaceSetting((newVal) => {
        spaceSetting.value = newVal;
    });
    const spaceCapacity = ref({});
    spaceService.subscribeSpaceCapacity((newVal) => {
        spaceCapacity.value = newVal;
    });
    const spacePermission = ref({});
    spaceService.subscribeSpacePermission((newVal) => {
        spacePermission.value = newVal;
    });
    /** 权限获取失败, 或有权限 */
    const ensureSpacePermission = computed(() => {
        return _.isEmpty(spacePermission.value) || spacePermission.value.enable_access;
    });
    const isFetchingSpaceData = ref(true);
    const initSpace = async (spaceId) => {
        if (!spaceId)
            return;
        isFetchingSpaceData.value = true;
        try {
            const res = await spaceService.initSpace(spaceId);
            if (ensureSpacePermission.value) {
                spaceService.updateSpaceAccessTime(spaceId);
            }
            return res;
        }
        finally {
            isFetchingSpaceData.value = false;
        }
    };
    const updateSpaceInfo = (spaceInfo) => {
        spaceService.updateSpaceInfo(spaceInfo);
    };
    const updateSpaceSettingLanguage = (language) => {
        spaceService.updateSpaceSettingLanguage(language);
    };
    const updateSpaceSetting = (spaceSetting) => {
        spaceService.updateSpaceSetting(spaceSetting);
    };
    const updateSpacePermission = (spacePermission) => {
        spaceService.updateSpacePermission(spacePermission);
    };
    return {
        spaceInfo,
        spaceSetting,
        spaceCapacity,
        spacePermission,
        ensureSpacePermission,
        spaceId,
        isFetchingSpaceData,
        initSpace,
        updateSpaceInfo,
        updateSpaceSettingLanguage,
        updateSpaceSetting,
        updateSpacePermission,
    };
});
